export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  category: CategoryType;
  year: number;
  rating: number;
  posterUrl: string;
  posterQuery: string;
  description: string;
  longDescription: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  featured: boolean;
  updateDate: string;
}

export type CategoryType = 'movie' | 'tv' | 'variety' | 'anime';

export interface CategoryInfo {
  key: CategoryType;
  label: string;
  icon: string;
  description: string;
}

export const categories: CategoryInfo[] = [
  { key: 'movie', label: '电影', icon: 'ri-film-line', description: '院线大片、经典电影、高分佳作，一网打尽' },
  { key: 'tv', label: '电视剧', icon: 'ri-tv-line', description: '热门国产剧、海外剧集，更新及时追剧不等待' },
  { key: 'variety', label: '综艺', icon: 'ri-live-line', description: '热门综艺、真人秀、脱口秀，欢乐不间断' },
  { key: 'anime', label: '动漫', icon: 'ri-rocket-line', description: '日漫国漫、经典番剧，二次元世界任你遨游' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: 'movie',
    year: 2025,
    rating: 9.2,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20featuring%20a%20giant%20planet%20engine%20in%20deep%20space%20with%20warm%20orange%20and%20gold%20lighting%2C%20dramatic%20cinematic%20composition%2C%20atmospheric%20cosmic%20background%2C%20film%20poster%20style%20with%20Chinese%20typography%20aesthetic%2C%20epic%20scale%2C%20clean%20minimal%20design%20with%20centered%20subject%2C%20professional%20movie%20poster%20photography&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    posterQuery: 'Chinese sci-fi movie poster featuring a giant planet engine in deep space with warm orange and gold lighting, dramatic cinematic composition, atmospheric cosmic background, film poster style with Chinese typography aesthetic, epic scale, clean minimal design with centered subject, professional movie poster photography',
    description: '太阳急速老化，人类被迫开启"流浪地球计划"。在浩瀚宇宙中，一场关乎文明存亡的史诗冒险再次展开。',
    longDescription: '在不远的未来，太阳急速衰老膨胀，地球面临被吞没的灭顶之灾。为拯救地球，人类在地球表面建造了上万座行星发动机，以逃离太阳系寻找新的家园，地球和人类就此踏上预计长达2500年的宇宙流浪之旅。在完成这一宏伟计划的进程中，无数人挺身而出，上演了可歌可泣的传奇故事，九死一生的冒险和对人性的终极拷问也同时上演。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '148分钟',
    region: '中国大陆',
    tags: ['科幻', '冒险', '灾难', 'IMAX'],
    isHot: true,
    isNew: true,
    featured: true,
    updateDate: '2025-07-28',
  },
  {
    id: 'movie-2',
    title: '哪吒之魔童闹海',
    englishTitle: 'Nezha: The Devil Child Rages',
    category: 'anime',
    year: 2025,
    rating: 9.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20of%20a%20mythological%20boy%20warrior%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20dramatic%20fire%20and%20water%20elements%20surrounding%2C%20traditional%20Chinese%20art%20style%20with%20modern%203D%20rendering%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20heroic%20pose%2C%20movie%20poster%20design%20with%20epic%20composition&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    posterQuery: 'Chinese animated film poster of a mythological boy warrior with flaming wheels and red ribbon, dramatic fire and water elements surrounding, traditional Chinese art style with modern 3D rendering, vibrant red and gold color scheme, heroic pose, movie poster design with epic composition',
    description: '天劫之后，哪吒与敖丙的灵魂虽得以保全，但面临魂飞魄散的危机。太乙真人打算用七色宝莲为二人重塑肉身。',
    longDescription: '天劫之后，哪吒、敖丙的灵魂虽保住，但很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。但是在重塑肉身的过程中却遇到重重困难，哪吒、敖丙的命运将走向何方？与此同时，东海龙王敖光为了敖丙的安危誓要陈塘关血债血偿，四海龙王联手来袭，一场前所未有的危机正等待着哪吒和他的伙伴们。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    duration: '110分钟',
    region: '中国大陆',
    tags: ['动画', '神话', '奇幻', '3D'],
    isHot: true,
    isNew: true,
    featured: true,
    updateDate: '2025-07-30',
  },
  {
    id: 'movie-3',
    title: '封神第二部：战火西岐',
    englishTitle: 'Creation of the Gods II: War of Xiqi',
    category: 'movie',
    year: 2025,
    rating: 8.9,
    posterUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20war%20movie%20poster%20with%20ancient%20warriors%20in%20armor%20riding%20mythical%20beasts%2C%20dramatic%20battlefield%20with%20golden%20dust%20and%20flames%2C%20traditional%20Chinese%20mythological%20aesthetic%2C%20grand%20scale%20cinematic%20composition%2C%20rich%20bronze%20and%20crimson%20tones%2C%20film%20poster%20style&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    posterQuery: 'Epic Chinese fantasy war movie poster with ancient warriors in armor riding mythical beasts, dramatic battlefield with golden dust and flames, traditional Chinese mythological aesthetic, grand scale cinematic composition, rich bronze and crimson tones, film poster style',
    description: '殷商大军兵临西岐，姜子牙与姬发率领西岐军民奋起反抗，一场惊天地泣鬼神的大战拉开帷幕。',
    longDescription: '殷商大军兵临城下，西岐保卫战一触即发。姜子牙临危受命，率领西岐军民奋起反抗。两大阵营各显神通，一场关于"封神榜"的争夺大战震撼开启。在战火纷飞中，姬发逐渐成长为真正的领袖，而殷郊则为了心中的执念，不惜一切代价。',
    director: '乌尔善',
    actors: ['黄渤', '于适', '那尔那茜', '陈坤', '费翔'],
    duration: '156分钟',
    region: '中国大陆',
    tags: ['奇幻', '战争', '神话', '史诗'],
    isHot: true,
    isNew: false,
    featured: true,
    updateDate: '2025-07-15',
  },
  {
    id: 'movie-4',
    title: '庆余年第二季',
    englishTitle: 'Joy of Life Season 2',
    category: 'tv',
    year: 2025,
    rating: 9.3,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20a%20scholar%20in%20traditional%20robes%20holding%20a%20fan%2C%20elegant%20ancient%20Chinese%20palace%20background%2C%20soft%20golden%20and%20jade%20green%20tones%2C%20refined%20classical%20aesthetic%2C%20drama%20series%20poster%20design%2C%20mysterious%20atmosphere&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    posterQuery: 'Chinese historical drama TV series poster with a scholar in traditional robes holding a fan, elegant ancient Chinese palace background, soft golden and jade green tones, refined classical aesthetic, drama series poster design, mysterious atmosphere',
    description: '范闲从北齐归来，京都风云再起。面对重重阴谋，他步步为营，在权谋与江湖之间走出自己的道路。',
    longDescription: '范闲从北齐归来后，发现京都暗流涌动。二皇子与太子的夺嫡之争愈演愈烈，监察院内部分裂，范闲被迫卷入更深的权谋漩涡。在陈萍萍、五竹等人的帮助下，范闲步步为营，逐渐揭开隐藏在庆国背后的惊天秘密。与此同时，他与林婉儿的感情也面临新的考验。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    duration: '36集',
    region: '中国大陆',
    tags: ['古装', '权谋', '武侠', '剧情'],
    isHot: true,
    isNew: true,
    featured: true,
    updateDate: '2025-07-25',
  },
  {
    id: 'movie-5',
    title: '速度与激情11',
    englishTitle: 'Fast & Furious 11',
    category: 'movie',
    year: 2025,
    rating: 8.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20sports%20cars%20racing%20through%20a%20city%20at%20sunset%2C%20dramatic%20orange%20sky%2C%20motion%20blur%20effect%2C%20high%20octane%20energy%2C%20ensemble%20cast%20posing%20with%20cars%2C%20blockbuster%20film%20poster%20style%2C%20cinematic%20lighting&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    posterQuery: 'Hollywood action movie poster with sports cars racing through a city at sunset, dramatic orange sky, motion blur effect, high octane energy, ensemble cast posing with cars, blockbuster film poster style, cinematic lighting',
    description: '唐老大和他的家人们面对前所未有的大危机，这一次，他们的战场扩大到全球范围。',
    longDescription: '在经历了无数次的生死考验后，唐老大和他的家人们以为终于可以过上平静的生活。然而，一个来自过去的阴影再次笼罩了他们。一个拥有强大势力的神秘组织威胁着全球安全，唐老大必须再次召集他的团队，驾驶着他们最爱的座驾，展开一场横跨全球的终极任务。',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·斯坦森', '米歇尔·罗德里格兹', '道恩·强森'],
    duration: '142分钟',
    region: '美国',
    tags: ['动作', '犯罪', '赛车', '冒险'],
    isHot: true,
    isNew: false,
    featured: false,
    updateDate: '2025-07-10',
  },
  {
    id: 'movie-6',
    title: '乘风破浪的姐姐2025',
    englishTitle: 'Sisters Who Make Waves 2025',
    category: 'variety',
    year: 2025,
    rating: 8.8,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20multiple%20elegant%20women%20in%20stunning%20stage%20costumes%2C%20glamorous%20stage%20lighting%20with%20sparkles%2C%20vibrant%20magenta%20and%20gold%20color%20palette%2C%20music%20performance%20theme%2C%20polished%20entertainment%20show%20poster%20design&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    posterQuery: 'Chinese variety show poster with multiple elegant women in stunning stage costumes, glamorous stage lighting with sparkles, vibrant magenta and gold color palette, music performance theme, polished entertainment show poster design',
    description: '全新一季姐姐们集结！三十位30+女艺人齐聚舞台，用实力和魅力重新定义"姐姐"的无限可能。',
    longDescription: '《乘风破浪的姐姐》第五季重磅回归！三十位来自不同领域的30+女性艺人汇聚一堂，她们中有演员、歌手、主持人、舞者，每个人都带着独特的人生故事和舞台梦想。在接下来的三个月里，她们将通过一次次的公演舞台，展现成熟女性独有的魅力与力量。这不仅是一场比赛，更是一场关于勇气、成长和蜕变的精彩旅程。',
    director: '吴梦知',
    actors: ['那英', '宁静', '张雨绮', '万茜', '金晨'],
    duration: '12期',
    region: '中国大陆',
    tags: ['真人秀', '音乐', '竞演', '女性'],
    isHot: false,
    isNew: true,
    featured: false,
    updateDate: '2025-07-20',
  },
  {
    id: 'movie-7',
    title: '鬼灭之刃：无限城篇',
    englishTitle: 'Demon Slayer: Infinity Castle',
    category: 'anime',
    year: 2025,
    rating: 9.4,
    posterUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20film%20poster%20with%20a%20young%20swordsman%20in%20traditional%20uniform%20wielding%20a%20katana%2C%20mysterious%20castle%20interior%20with%20floating%20platforms%2C%20dramatic%20dark%20and%20crimson%20color%20scheme%2C%20dynamic%20action%20pose%2C%20anime%20movie%20poster%20art%20style%2C%20intense%20atmosphere&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    posterQuery: 'Japanese anime film poster with a young swordsman in traditional uniform wielding a katana, mysterious castle interior with floating platforms, dramatic dark and crimson color scheme, dynamic action pose, anime movie poster art style, intense atmosphere',
    description: '炭治郎和鬼杀队成员们被传送到了鬼舞辻无惨的老巢——无限城，最终决战一触即发！',
    longDescription: '在经历了柱训练之后，炭治郎和鬼杀队的成员们终于迎来了与鬼舞辻无惨的最终决战。然而他们被传送到了无惨的老巢——无限城，一个由无数房间和走廊组成的诡异空间。在这里，各位柱将与上弦之鬼展开一对一的生死对决，而炭治郎则要面对他宿命中的对手。人类与鬼之间延续千年的战争，即将迎来最后的结局。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    duration: '128分钟',
    region: '日本',
    tags: ['热血', '战斗', '奇幻', '剧场版'],
    isHot: true,
    isNew: true,
    featured: false,
    updateDate: '2025-07-29',
  },
  {
    id: 'movie-8',
    title: '三体：黑暗森林',
    englishTitle: 'Three-Body: The Dark Forest',
    category: 'tv',
    year: 2025,
    rating: 9.6,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20a%20cosmic%20scale%2C%20three%20suns%20in%20a%20strange%20configuration%20in%20deep%20space%2C%20mysterious%20dark%20forest%20metaphor%2C%20cold%20blue%20and%20silver%20tones%2C%20philosophical%20and%20grand%20atmosphere%2C%20high-end%20sci-fi%20drama%20poster%20design&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    posterQuery: 'Chinese sci-fi TV series poster with a cosmic scale, three suns in a strange configuration in deep space, mysterious dark forest metaphor, cold blue and silver tones, philosophical and grand atmosphere, high-end sci-fi drama poster design',
    description: '三体舰队正以光速向地球驶来，人类面临前所未有的危机。面壁计划启动，四位面壁者肩负起拯救人类文明的使命。',
    longDescription: '三体危机出现后，人类在面对前所未有的外星威胁时展开了自救行动。联合国启动了"面壁计划"，指定四位面壁者，他们拥有调动全球资源的权力，通过隐藏真实战略意图来欺骗三体文明。与此同时，由三体在地球的代理人组成的"破壁人"组织，也在暗中破解面壁者的计划。在这场关乎两个文明存亡的博弈中，宇宙的黑暗森林法则逐渐浮出水面。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    duration: '30集',
    region: '中国大陆',
    tags: ['科幻', '悬疑', '哲学', '史诗'],
    isHot: true,
    isNew: true,
    featured: true,
    updateDate: '2025-07-31',
  },
  {
    id: 'movie-9',
    title: '热辣滚烫2',
    englishTitle: 'YOLO 2',
    category: 'movie',
    year: 2025,
    rating: 8.6,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy-drama%20film%20poster%20featuring%20a%20determined%20woman%20in%20boxing%20gloves%2C%20warm%20sunset%20lighting%2C%20urban%20rooftop%20setting%2C%20inspirational%20and%20uplifting%20mood%2C%20soft%20golden%20hour%20tones%2C%20film%20poster%20with%20motivational%20vibe&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    posterQuery: 'Chinese comedy-drama film poster featuring a determined woman in boxing gloves, warm sunset lighting, urban rooftop setting, inspirational and uplifting mood, soft golden hour tones, film poster with motivational vibe',
    description: '乐莹在经历了人生的蜕变之后，面对新的挑战和选择。这一次，她要为自己的人生再拼一把。',
    longDescription: '在经历了上一次的人生大转变后，乐莹已经不再是那个迷茫的女孩。她在拳击的世界里找到了自己的方向，但生活从来不会一帆风顺。新的挑战接踵而至：事业上的瓶颈、感情的纠葛、家庭的压力，这一切都在考验着她的决心。但乐莹知道，人生只有一次，她要为自己而活，为自己而战。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    duration: '135分钟',
    region: '中国大陆',
    tags: ['喜剧', '剧情', '励志', '运动'],
    isHot: false,
    isNew: false,
    featured: false,
    updateDate: '2025-06-20',
  },
  {
    id: 'movie-10',
    title: '大奉打更人',
    englishTitle: 'Guardians of the Dafeng',
    category: 'tv',
    year: 2025,
    rating: 8.7,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20detective%20drama%20poster%20with%20a%20young%20man%20in%20ancient%20official%20uniform%20holding%20a%20sword%2C%20mysterious%20ancient%20Chinese%20city%20at%20night%2C%20warm%20lantern%20light%2C%20historical%20fantasy%20atmosphere%2C%20drama%20series%20poster%20design&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    posterQuery: 'Chinese fantasy detective drama poster with a young man in ancient official uniform holding a sword, mysterious ancient Chinese city at night, warm lantern light, historical fantasy atmosphere, drama series poster design',
    description: '警校毕业的许七安穿越到大奉王朝，凭借现代刑侦知识在古代破案升官，走上一条热血传奇之路。',
    longDescription: '现代警校高材生许七安，在一次意外中穿越到了架空的大奉王朝。在这个充满玄幻色彩的世界里，他凭借扎实的现代刑侦知识和敏锐的观察力，从一个小小打更人做起，屡破奇案。从宫廷斗争到江湖恩怨，从妖魔鬼怪到人心叵测，许七安在破案的过程中一步步揭开大奉王朝背后的惊天秘密。',
    director: '邓科',
    actors: ['王鹤棣', '田曦薇', '刘奕君', '晏紫东'],
    duration: '40集',
    region: '中国大陆',
    tags: ['古装', '探案', '奇幻', '喜剧'],
    isHot: true,
    isNew: false,
    featured: false,
    updateDate: '2025-07-05',
  },
  {
    id: 'movie-11',
    title: '王牌对王牌第九季',
    englishTitle: 'Ace vs Ace Season 9',
    category: 'variety',
    year: 2025,
    rating: 8.3,
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20game%20show%20poster%20with%20celebrities%20in%20colorful%20team%20outfits%2C%20bright%20studio%20stage%20with%20game%20elements%2C%20fun%20and%20energetic%20atmosphere%2C%20vibrant%20rainbow%20color%20palette%2C%20entertainment%20show%20poster%20design&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    posterQuery: 'Chinese variety game show poster with celebrities in colorful team outfits, bright studio stage with game elements, fun and energetic atmosphere, vibrant rainbow color palette, entertainment show poster design',
    description: '全新一季王牌家族回归！沈腾、贾玲领衔，经典游戏全新升级，笑料不断，温情满满。',
    longDescription: '《王牌对王牌》第九季强势回归！王牌家族沈腾、贾玲、华晨宇、关晓彤再次集结，与新加入的飞行嘉宾一起，在经典与创新的游戏中展开欢乐对决。本季不仅有让人捧腹的搞笑环节，还融入了更多温情时刻和文化传承元素。每一期都是一场视听盛宴，让观众在欢笑中感受温暖与感动。',
    director: '吴彤',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    duration: '12期',
    region: '中国大陆',
    tags: ['游戏', '搞笑', '真人秀', '合家欢'],
    isHot: false,
    isNew: true,
    featured: false,
    updateDate: '2025-07-18',
  },
  {
    id: 'movie-12',
    title: '排球少年！！垃圾场的决战',
    englishTitle: 'Haikyu!! The Dumpster Battle',
    category: 'anime',
    year: 2025,
    rating: 9.1,
    posterUrl: 'https://readdy.ai/api/search-image?query=Sports%20anime%20film%20poster%20with%20volleyball%20players%20jumping%20for%20a%20spike%2C%20dynamic%20action%20pose%2C%20indoor%20gymnasium%20with%20dramatic%20lighting%2C%20intense%20sports%20atmosphere%2C%20orange%20and%20teal%20color%20contrast%2C%20energetic%20anime%20movie%20poster%20style&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    posterQuery: 'Sports anime film poster with volleyball players jumping for a spike, dynamic action pose, indoor gymnasium with dramatic lighting, intense sports atmosphere, orange and teal color contrast, energetic anime movie poster style',
    description: '乌野高中vs音驹高中，这场被粉丝期待已久的"垃圾场对决"终于在大银幕上热血呈现！',
    longDescription: '在全国大赛的舞台上，乌野高中和音驹高中这两支宿命般的对手终于相遇了。日向翔阳和孤爪研磨，两个性格截然不同的排球少年，在这场被称为"垃圾场对决"的比赛中全力以赴。每一记扣杀、每一次救球，都倾注着他们对排球的热爱和执着。这不只是一场比赛，更是青春最热血的见证。',
    director: '满仲劝',
    actors: ['村濑步', '石川界人', '日野聪', '入野自由'],
    duration: '105分钟',
    region: '日本',
    tags: ['运动', '热血', '青春', '剧场版'],
    isHot: false,
    isNew: false,
    featured: false,
    updateDate: '2025-06-15',
  },
];

export const getMoviesByCategory = (category: CategoryType): Movie[] => {
  return movies.filter(m => m.category === category);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter(m => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter(m => m.isNew);
};

export const getFeaturedMovies = (): Movie[] => {
  return movies.filter(m => m.featured);
};

export const getMovieById = (id: string): Movie | undefined => {
  return movies.find(m => m.id === id);
};